import React, { useState, useEffect, useMemo } from "react";
import {
  Grid2,
  Typography,
  MenuItem,
  Box,
  Paper,
  Select,
  Chip,
  Card,
  Snackbar,
  Alert,
  Autocomplete
} from "@mui/material";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { getContentTypes } from "../../actions/contentActions";

import { useDispatch, useSelector } from "react-redux";
import { usePermission } from "../authentication/permission-providor/UserPermission";

//Abdllah
import { Link, useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import EditIcon from "../../components/icons/EditIcon";

import { getAllEntries, removeEntry } from "../../actions/entryActions";
import CheckIcon from "@mui/icons-material/Check";
import RemoveIcon from "../../components/icons/RemoveIcon";
import AddButton from "../../themes/overrides/AddButton";
import CopyIcon from "../../components/icons/CopyIcon"
import ContentPopup from "./ContentPopup";
import SearchField from "../../themes/overrides/SearchField";
import { DataGrid } from "@mui/x-data-grid";

import DefaulImg from "../../assets/images/grayRectangle.png";
import DefaulImg2 from "../../assets/images/rec_image.png";

import DropDownMenu from "../../themes/overrides/DropDownMenu";
import BrushIcon from "../../assets/images/brush.svg";


import CloudDoneOutlinedIcon from "@mui/icons-material/CloudDoneOutlined";
import CloudOffOutlinedIcon from "@mui/icons-material/CloudOffOutlined";
import CustomCardMedia from "../../themes/overrides/CustomCardMedia";
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import LoadingOverlay from "../../components/LoadingOverlay";
import DeleteConfirmationModal from "../../components/DeleteConfirmationModal";
import ListIcon from "../../components/icons/ListIcon";
import GridIcon from "../../components/icons/GridIcon";
import TextFieldInput from '../../themes/overrides/TextFieldInput';
import { useParams } from 'react-router-dom';

const AllContents = () => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedContentType, setSelectedContentType] = useState("");

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedContentToDelete, setSelectedContentToDelete] = useState(null);
  const theme = useTheme();
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const { hasPermission } = usePermission();


  const [gridColor, setGridColor] = useState("#6B6B6B");
  const [listColor, setListColor] = useState("#6B6B6B");

  const contentTypes = useSelector((state) => state.form.contentTypes);
  const { workspaceId } = useParams();
  const data = useSelector((state) => state.entry.entries);

  const [searchTerm, setSearchTerm] = useState("");

  const [viewMode, setViewMode] = useState("list");
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");

  const [selectedFilterdValue, setSelectedFilteredValue] = useState(null);

  function getMediaFieldIds(contentModelId) {
    // Find the content model with the specified _id
    const contentModel = contentTypes.find(model => model._id === contentModelId);

    if (!contentModel) {
      return `Content model with _id ${contentModelId} not found.`;
    }

    // Filter fields of type 'media' and return their ids
    const mediaFieldIds = contentModel.fields
      .filter(field => field.type === "media")
      .map(field => field.id);

    return mediaFieldIds;
  }

  const handleToggleView = (view) => {
    if (view === "List") {
      setViewMode("list");
      setListColor("#006D70");
      setGridColor("#6B6B6B");
    } else {
      setViewMode("grid");
      setGridColor("#006D70");
      setListColor("#6B6B6B");
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleSelectContentType = (contentType, id) => {
    setSelectedContentType(contentType);
    console.log(id);
    //load the content fields

    setIsModalOpen(true); // Open modal
    handleCloseMenu();
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedContentType(""); // Reset selected content type
  };

  useEffect(() => {
    if (workspaceId) {
      setLoading(true); // Start loading
      Promise.all([
        dispatch(getContentTypes(workspaceId)),
        dispatch(getAllEntries(workspaceId)),
      ]).finally(() => setLoading(false));
      // dispatch(getContentTypes(workspaceId));
      // dispatch(getAllEntries(workspaceId));
    }
  }, [workspaceId]);

  const navigate = useNavigate();

  const navigateCreateEntryPage = (workspaceId, id) => {
    navigate(`/${workspaceId}/create-entry/${id}`);
  };

  const navigateEditEntryPage = (workspaceId, params) => {
    navigate(`/${workspaceId}/edit-entry/${params.row._id}`);
  };



  const handleCloseSnackbar = () => setSnackbar({ ...snackbar, open: false });

  const columns = [
    {
      field: "image",
      headerName: "Image",
      renderCell: (params) => (
        <Card
          sx={{
            padding: 1,
            justifyContent: "center",
            margin: "2px auto",
            display: "block",
            alignItems: "center",
          }}
        >
          <CustomCardMedia
            component="img"
            image={params?.row?.data?.[getMediaFieldIds(params?.row?.contentTypeId)?.[0]]?.[0]?.url ?? DefaulImg}
            alt="image"
          ></CustomCardMedia>
        </Card>
      ),
    },
    // { field: "id", headerName: "ID",flex:1 },
    { field: "identifier", headerName: "Identifier", flex: 1 },
    { field: "content_type_name", headerName: "Content type", flex: 1 },
    {
      field: "published",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => (
        <Box>
          {params.row.published ? (
            <Chip
              icon={<CloudDoneOutlinedIcon />}
              label="Published"
              size="small"
              color="#D4F5F5"
              style={{ backgroundColor: "#D4F5F5" }}
            />
          ) : (
            <Chip
              icon={<CloudOffOutlinedIcon />}
              label="Draft"
              size="small"
              color="#F0F0F0"
            />
          )}
        </Box>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => (
        <Box>
          <IconButton
            color="secondary"
            onClick={() => navigateEditEntryPage(workspaceId, params)}
            aria-label="edit"
          >
            <EditIcon />
          </IconButton>
          <IconButton
            color="secondary"
            onClick={() => handleDelete(params.row._id)}
            aria-label="delete"
            disabled={!hasPermission('admin')}
          >
            <RemoveIcon />
          </IconButton>
          <IconButton
            color="secondary"
            onClick={() => handleCopy(params.row._id)}
            aria-label="copy"
          >
            <CopyIcon />
          </IconButton>
        </Box>
      ),
    },
  ];

  const filteredRows = useMemo(() => {
    if (!Array.isArray(data)) return [];

    // Apply filtering
    const filtered = data.filter((content) =>
      [content.identifier, content.content_type_name]
        .join(" ")
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    );

    // Apply sorting
    if (sortField) {
      filtered.sort((a, b) => {
        if (!a[sortField]) return sortOrder === "asc" ? -1 : 1;
        if (!b[sortField]) return sortOrder === "asc" ? 1 : -1;
        return sortOrder === "asc"
          ? a[sortField].localeCompare(b[sortField])
          : b[sortField].localeCompare(a[sortField]);
      });
    }

    // Apply filter on contentType
    if (selectedFilterdValue) {
      const contentTypeFiltered = filtered.filter((content) => {
        return content.content_type_name === selectedFilterdValue.name
      });
      return contentTypeFiltered.map((contentType, index) => ({
        id: index,
        ...contentType,
      }));

    }

    // Map the data to include IDs for DataGrid
    return filtered.map((contentType, index) => ({
      id: index,
      ...contentType,
    }));
  }, [data, searchTerm, sortField, sortOrder, selectedFilterdValue]);


  const handleSortChange = (event) => {
    const value = event.target.value;
    if (value === "Sort by") {
      setSortField(null);
    } else if (value === "Identifier") {
      setSortField("identifier");
      setSortOrder("asc"); // Default to ascending order
    } else if (value === "Content Type") {
      setSortField("content_type_name");
      setSortOrder("asc"); // Default to ascending order
    }
  };


  const handleEdit = (id) => {
    navigate(`/${workspaceId}/edit-entry/${id}`);
  };

  const handleDelete = (id) => {
    setSelectedContentToDelete(id);
    setDeleteModalOpen(true);
  };

  const handleConfirmDelete = () => {
    try {
      dispatch(removeEntry(selectedContentToDelete));

      setSnackbar({ open: true, message: "Entry deleted successfully!", severity: "success" });
    } catch (error) {
      setSnackbar({ open: true, message: "Failed to delete entry.", severity: "error" })
    } finally {
      setDeleteModalOpen(false);
      setSelectedContentToDelete(null);
    }
  };

  const handleCopy = async (id) => {
    try {
      const textToCopy = id;
      await navigator.clipboard.writeText(textToCopy);
      setSnackbar({ open: true, message: "Content copied to clipboard!", severity: "success" });

    } catch (err) {
      setSnackbar({ open: true, message: "Failed to copy", severity: "error" })

    }
  }

  const handleSearch = (event) => {
    setSearchTerm(event.target.value.toLowerCase());
  };

  return (
    loading ? <LoadingOverlay /> :
      <Grid2 container spacing={2}>
        <Grid2 size={12} justifyContent="space-between"
          sx={{
            display: 'flex',
            flexDirection: {
              xs: 'column',
              md: 'row',
            },
          }}
        >
          <Grid2 size={{ xs: 12, md: 6 }} display="flex" alignItems="center" sx={{ marginLeft: { xs: 4, md: 0 } }}>
            <Box component="img" sx={{ width: { xs: 32, md: 40 }, marginRight: { xs: 2, md: 4 } }} src={BrushIcon} />
            <Typography variant="h1">All Contents</Typography>
          </Grid2>

          <Grid2 size={{ xs: 12, md: 4 }} sx={{ marginTop: { xs: 1, md: 0 } }} display="flex" justifyContent="flex-end">
            <PopupState variant="popover" popupId="demo-popup-menu">
              {(popupState) => (
                <>
                  <AddButton

                    label="Add Entry"
                    variant="contained"
                    {...bindTrigger(popupState)}
                    disabled={!hasPermission('editor')}
                  />
                  <DropDownMenu {...bindMenu(popupState)}>
                    {contentTypes.map((contentType) => (
                      <MenuItem
                        key={contentType._id}
                        onClick={() =>
                          navigateCreateEntryPage(
                            contentType.workspaceId,
                            contentType._id
                          )
                        }
                      >
                        {contentType.name}
                      </MenuItem>
                    ))}
                  </DropDownMenu>
                </>
              )}
            </PopupState>
          </Grid2>
        </Grid2>

        <Grid2 size={12} container >
          <Grid2 size={12}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: {
                  xs: 'column',
                  md: 'row',
                },
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
                pt: 2,
                borderRadius: 2,
              }}
            >
              <SearchField
                placeholder="Search Content"
                variant="outlined"
                value={searchTerm}
                onChange={handleSearch}
                sx={{
                  mb: {
                    xs: 1,
                    md: 0
                  }
                }}
              />
              <Autocomplete
                sx={{
                  flex: 1, background: 'white', borderColor: ' #ACACAC',
                  '& .MuiOutlinedInput-root': { padding: '4px' },
                }}
                options={contentTypes}
                getOptionLabel={(option) => option.name}
                value={selectedFilterdValue}
                onChange={(event, newValue) => setSelectedFilteredValue(newValue)}
                noOptionsText="No content type found"
                renderInput={(params) => (
                  <TextFieldInput
                    {...params}
                    label="Filter by Content Type"
                    fullWidth
                    sx={{
                      minWidth: 225,
                    }}
                    placeholder="Type to search..."

                  />
                )}
              />

              <Box display="flex" justifyContent="space-between" sx={{ gap: 2 }} >
                <Box sx={{ border: '1px solid #6B6B6B', borderRadius: 2, background: 'white' }}>
                  <IconButton onClick={() => handleToggleView("List")}>
                    <ListIcon toggleColor={listColor} />
                  </IconButton>
                  <IconButton onClick={() => handleToggleView("Grid")}>
                    <GridIcon toggleColor={gridColor} />
                  </IconButton>
                </Box>


                <Select
                  size="small"
                  defaultValue="Sort by"
                  sx={{ minWidth: 200, color: '#6B6B6B', borderRadius: 2, border: '1px solid #6B6B6B', background: 'white' }}
                  onChange={handleSortChange}
                >
                  <MenuItem value="Sort by">Sort by</MenuItem>
                  <MenuItem value="Identifier">Identifier</MenuItem>
                  <MenuItem value="Content Type">Content Type</MenuItem>
                </Select>
              </Box>
            </Box>
          </Grid2>

          <Grid2 size={12} sx={{ overflowX: 'auto' }}>
            <Paper elevation={2} sx={{ padding: 2, marginBottom: 2, marginTop: { md: 2 }, overflowX: 'auto' }}>
              {filteredRows.length > 0 ? (
                viewMode === "list" ? (
                  <Box
                    sx={{
                      width: '100%',
                      overflowX: 'auto',
                    }}
                  >
                    <DataGrid
                      rows={filteredRows}
                      columns={columns}
                      disableColumnSelector
                      disableRowSelectionOnClick
                      disableColumnMenu
                      initialState={{
                        pagination: {
                          paginationModel: {
                            pageSize: 15,
                          },
                        },
                      }}
                      pageSizeOptions={[15]}
                      sx={{
                        minWidth: 600,
                        '& .MuiDataGrid-cell:focus': {
                          outline: 'none'
                        },
                      }}
                    />
                  </Box>
                ) : (
                  <Grid2 container spacing={2} sx={{ flexWrap: 'wrap' }}>
                    {filteredRows.map((data, i) => (
                      <Grid2 key={i} size={{ xs: 12, md: 3 }}>
                        {/* Content Card */}
                        <Box sx={{ border: "1px solid #ddd", borderRadius: 2 }}>
                          <Box
                            component="img"
                            sx={{
                              width: '100%',
                              height: 'auto',
                            }}
                            src={data.data?.[getMediaFieldIds(data?.contentTypeId)?.[0]]?.[0]?.url ?? DefaulImg}
                            alt="Cancel Icon"
                          />
                          {/* <img
                             
                              style={{ width: '100%' }}
                            /> */}
                          {/* </Box> */}
                          <Box p={2}>
                            <Typography variant="body1">
                              {data.identifier}
                            </Typography>
                          </Box>
                          <Box paddingLeft={2}>
                            <Chip icon={<LocalOfferOutlinedIcon />} label={data.content_type_name} size="small" />
                          </Box>
                          <Box paddingLeft={2}>
                            <Chip
                              icon={data.published ? <CloudDoneOutlinedIcon /> : <CloudOffOutlinedIcon />}
                              label={data.published ? "Published" : "Draft"}
                              size="small"
                              color={data.published ? "D4F5F5" : "#D4F5F5"}
                            />
                          </Box >

                          <Box paddingLeft={2} display="flex">
                            <IconButton
                              color="secondary"
                              onClick={() => handleEdit(data._id)}
                              aria-label="edit"
                            >
                              <EditIcon />
                            </IconButton>
                            <IconButton
                              color="secondary"
                              onClick={() => handleDelete(data._id)}
                              aria-label="delete"
                              disabled={!hasPermission('admin')}
                            >
                              <RemoveIcon />
                            </IconButton>
                            <IconButton
                              color="secondary"
                              onClick={() => handleCopy(data._id)}
                              aria-label="copy"
                            >
                              <CopyIcon />
                            </IconButton>
                          </Box>
                        </Box>
                      </Grid2>
                    ))
                    }
                  </Grid2>
                )) : (
                <Typography align="center">No Contents</Typography>
              )}
            </Paper>
          </Grid2>
        </Grid2>

        <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
          <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: "100%" }}
            variant="filled">
            {snackbar.message}
          </Alert>
        </Snackbar>

        <DeleteConfirmationModal

          open={deleteModalOpen}
          onClose={() => {
            setDeleteModalOpen(false);
            setSelectedContentToDelete(null);
          }}
          text="Are you sure you want to delete this content?"
          onConfirm={handleConfirmDelete}
          deleteButtonLabel="Delete"
        />
      </Grid2>


  );
};

export default AllContents;
